/**
 * c-shortcode-product-text
 *
 * snippets/c-shortcode-product-text.liquid のカンマ区切り形式は、
 * Liquid の all_products[handle]（1ページ20ユニークハンドル上限）を使えないため、
 * プレースホルダ（.js-c-shortcode-product-text-async）のみ出力される。
 *
 * このスクリプトが各プレースホルダの data-handles を読み取り、
 * Section Rendering API（section_id=c-shortcode-product-text-item）を
 * マーケット文脈のまま叩いて、商品行を非同期で描画する。
 * これにより 20 ハンドル上限を完全に回避し、価格もマーケット通貨で正しく出る。
 */

const SECTION_ID = 'c-shortcode-product-text-item';

/**
 * Section Rendering API 用の、マーケット（ロケール）文脈付き商品URLを組み立てる。
 * @param {string} handle - 商品ハンドル
 * @returns {string} ロケールルートを含む section_id 付きパス
 */
const buildSectionUrl = (handle) => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return `${root}products/${encodeURIComponent(handle)}?section_id=${SECTION_ID}`;
};

/**
 * 1商品分の行を、現在のマーケット文脈で取得する。
 * 在庫なし・商品なしの場合はセクションが空で返るため null を返す。
 * @param {string} handle - 商品ハンドル
 * @returns {Promise<HTMLElement|null>} 描画済みの .c-shortcode-product-text__item か null
 */
const fetchProductItem = async (handle) => {
  try {
    const res = await fetch(buildSectionUrl(handle));
    if (!res.ok) return null;

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector('.c-shortcode-product-text__item');
  } catch (error) {
    console.error(`[c-shortcode-product-text] failed to load "${handle}"`, error);
    return null;
  }
};

/**
 * プレースホルダ1ブロックを解決する。
 * 全ハンドルを並列取得し、在庫ありの行のみを元の順序で data-limit 件まで描画する。
 * @param {HTMLElement} root - プレースホルダ要素
 * @returns {Promise<void>}
 */
const renderBlock = async (root) => {
  const handles = (root.dataset.handles || '')
    .split(',')
    .map((handle) => handle.trim())
    .filter(Boolean);

  if (handles.length === 0) return;

  const limit = parseInt(root.dataset.limit, 10) || handles.length;
  const items = await Promise.all(handles.map(fetchProductItem));

  const fragment = document.createDocumentFragment();
  let rendered = 0;

  for (const item of items) {
    if (rendered >= limit) break;
    if (!item) continue;

    fragment.appendChild(item);
    rendered += 1;
  }

  root.appendChild(fragment);
};

const blocks = document.querySelectorAll('.js-c-shortcode-product-text-async');
blocks.forEach((root) => {
  renderBlock(root);
});
